
import { computed, defineComponent, Ref } from 'vue';
import pageStore from '@/shared/content/page.store';
import breakpointsState from '@/core/responsive/breakpoints/breakpoints-state.observable';
import { pageLeftNavigationActiveBreakpointKey } from '@/shared/content/PageRender.vue';

export default defineComponent({
    name: 'BlockMaxWidthHandler',
    setup() {
        const isPageWithLeftNavigation: Ref<boolean> = computed(() => {
            return pageStore.hasLeftNavigation &&
                breakpointsState.isBreakpointActive(pageLeftNavigationActiveBreakpointKey);
        });

        return {
            isPageWithLeftNavigation,
        };
    },
});
